import React, { Component } from 'react'
import styled from 'styled-components'
import posed, { PoseGroup } from 'react-pose'

const PosedTime = posed.p({
  enter: {
    opacity: 1,
    x: 0
  },
  
  exit: {
    opacity: 0,
    x: -10
  }
})

const Time = styled(PosedTime)`
  font-family: 'Hill';
  font-size: 120px;
  color: ${props => props.theme.colors.grey.light};
  font-weight: 300;
  line-height: normal;
`

export default class TimeDisplay extends Component {
  render() {
    const {
      times,
      activeTime,
    } = this.props

    return(
      <PoseGroup withParent={false}>
        <Time key={activeTime}>
          {times[activeTime].hours}:{times[activeTime].minutes}
        </Time>
      </PoseGroup>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/DaySlider/TimeDisplay.js